if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.restockMessage = this.querySelector('.product-form__restock-message');
        this.dynamicCheckoutButton = this.querySelector('.shopify-payment-button');
        this.variantSelects = this.querySelectorAll('select[name="options[]"], input[name="options[]"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Bind event listeners for variant changes
        this.variantSelects.forEach(select => {
          select.addEventListener('change', this.onVariantChange.bind(this));
        });
      }

      onVariantChange() {
        // Get selected options
        const selectedOptions = Array.from(this.variantSelects).map(select => select.value);
        // Find the matching variant
        const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        const selectedVariant = variants.find(variant =>
          variant.options.every((option, index) => option === selectedOptions[index])
        );

        if (selectedVariant) {
          // Update variant ID in the form
          this.variantIdInput.value = selectedVariant.id;
          this.variantIdInput.disabled = !selectedVariant.available;

          // Update button, dynamic checkout, and restock message visibility
          if (selectedVariant.available) {
            if (this.submitButton) {
              this.submitButton.style.display = 'block';
              this.submitButton.removeAttribute('disabled');
              this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
            if (this.dynamicCheckoutButton) {
              this.dynamicCheckoutButton.style.display = 'block';
            }
            if (this.restockMessage) {
              this.restockMessage.style.display = 'none';
            }
          } else {
            if (this.submitButton) {
              this.submitButton.style.display = 'none';
            }
            if (this.dynamicCheckoutButton) {
              this.dynamicCheckoutButton.style.display = 'none';
            }
            if (this.restockMessage) {
              this.restockMessage.style.display = 'block';
              this.restockMessage.textContent = window.variantStrings.restockMessage || 'This item would be restocked within 2-3 weeks';
            }
          }

          // Notify pickup-availability of variant change
          const pickupAvailability = document.querySelector('pickup-availability');
          if (pickupAvailability) {
            pickupAvailability.update(selectedVariant);
          }
        } else {
          // No valid variant selected
          if (this.submitButton) {
            this.submitButton.style.display = 'none';
          }
          if (this.dynamicCheckoutButton) {
            this.dynamicCheckoutButton.style.display = 'none';
          }
          if (this.restockMessage) {
            this.restockMessage.style.display = 'block';
            this.restockMessage.textContent = window.variantStrings.unavailable || 'This item is unavailable';
          }
          // Clear pickup-availability
          const pickupAvailability = document.querySelector('pickup-availability');
          if (pickupAvailability) {
            pickupAvailability.update(null);
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section) // Use 'section' instead of 'id'
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, {
          ...config,
          cache: 'no-store', // Prevent caching to ensure fresh data
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  }, 50); // Small delay to ensure modal is closed
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Ensure cart drawer updates with fresh data
              this.cart.renderContents(response);
            }
          })
          .catch((e) => console.error('Cart add error:', e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}